import {Component, Input, Output, Injectable, EventEmitter} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {Router, RouterStateSnapshot, RoutesRecognized} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {GlobalVariable} from '../../../../app/config';
import {EmitterService} from "./emitter.service";
import * as moment from 'moment';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';


let headers = new Headers();
headers.append("Content-Type", "application/json");
headers.append('Access-Control-Allow-Origin', '*');
headers.append("Token", '');

@Injectable()
export class GlobalDataService {

  public BASE_URL = GlobalVariable.FORDAPIEndPointURL;
  public USER_TZ = '';
  //public usrobj = JSON.parse(localStorage.getItem("user"));
  public usrobj = JSON.parse(sessionStorage.getItem("user"));
  public path: any;
  public count: number = 0;
  public subscriptions: Array<Subscription> = [];
  public redirectUrl: string;

  constructor(private http: Http, public _router: Router, public _emitterService: EmitterService) {
    this._emitterService.getTZ().subscribe(value => {
      this.USER_TZ = value;
    });

  }

  /**
   * @author Nagendra
   * @description Get Leads count
   * @param userid
   */
  getLeadSummary(userid, callback) {
    this.GetAjaxCall(this.BASE_URL + "/lms/dashboard?userId=" + userid, (result) => {
      callback(result);
    })
  }

  /**
   * @author Pradeep
   * @description logout
   * @param user
   */

  logout(user, callback) {
    this.logoutAjaxCall(this.BASE_URL + "/user/logout", user, (result) => {
      callback(result);
      this._emitterService.setloadHeader(false)
    })
  }
  trackUserClick(userId,targetId){
    console.log("Tracking ! : "+targetId)
    const thisObj = this;
    this.http.post(this.BASE_URL+"/lms2/tracking/"+userId+"/"+targetId+"/", {})
      .subscribe(
        (data) => {console.log("done")},
        err => {}
      );
  }
  trackClick(userId,targetId,callback){
    console.log("Tracking ! : "+targetId)
    const thisObj = this;
    this.http.post(this.BASE_URL+"/lms2/tracking/"+userId+"/"+targetId+"/", {})
      .subscribe(
        (data) => {
          console.log("callback tracking")
          callback()

        },
        err => {
          console.log(err)
          console.log("failed")
        }
      );
  }

  GetAjaxCall(url: string, callback, loader = true) {
    const thisObj = this;
//        if(this.usrobj){
//            this.refreshToken();
//        }
    headers.delete('Token');
    //headers.append("Token", localStorage.getItem("token"));
    headers.append("Token", sessionStorage.getItem("token"));
    this.count++;
    if (loader)
      thisObj._emitterService.setSpinner(true);
    this.subscriptions.push(this.http.get(url, {headers: headers})
      .subscribe(
        (data) => {
          //console.log(data);
          const res = data.json();//For Success Response
          // for timer popup
          this.count--;
          if (this.count == 0) {
            thisObj._emitterService.setSpinner(false)
          }
          callback(res);
        },
        err => {
          this.count--;
          console.log("-----------------------");
          if(err.headers.ok == false ){
            this._router.navigate(['login'],{queryParams:{'redirectURL': this._router.routerState.snapshot.url}});
          }
          if (this.count == 0) {
            thisObj._emitterService.setSpinner(false)
          }
        }
      ));
  }



  PostAjaxCall(url: string, params: any, callback) {
    const thisObj = this;
//        if(this.usrobj){
//            this.refreshToken();
//        }
    headers.delete('Token');
    //headers.append("Token", localStorage.getItem("token"));
    headers.append("Token", sessionStorage.getItem("token"));
    this.count++;
    this._emitterService.setSpinner(true);
    this.subscriptions.push(this.http.post(url, params, {headers: headers})
      .subscribe(
        (data) => {
          const res = data.json();//For Success Response
          // for timer popup
          this.count--;
          if (this.count == 0) {
            thisObj._emitterService.setSpinner(false)
          }
          callback(res);
        },
        err => {
          this.count--;
          if (this.count == 0) {
            thisObj._emitterService.setSpinner(false)
          }
        }
      ));
  }

  PostAjaxMultipartCall(url: string, params: any, callback) {
    let headers = new Headers();
    //headers.append("Content-Type", "multipart/form-data");
    headers.append('Access-Control-Allow-Origin', '*');
    const thisObj = this;
    headers.append("Token", sessionStorage.getItem("token"));
    this.count++;
    this._emitterService.setSpinner(true);
    this.subscriptions.push(this.http.post(url, params, {headers: headers})
      .subscribe(
        (data) => {
          const res = data
          // for timer popup
          this.count--;
          if (this.count == 0) {
            thisObj._emitterService.setSpinner(false)
          }
          callback(res);
        },
        err => {
          this.count--;
          if (this.count == 0) {
            thisObj._emitterService.setSpinner(false)
          }
        }
      ));
  }

  /**
   * @author Pradeep
   * @param userid,searchTextfileds,offset,limit,callback
   * @returns Search List
   */
  getSearchLeadList(searchobj, callback) {
    this.PostAjaxCall(this.BASE_URL + "/lms/lead/searchWider", searchobj, (result) => {
      callback(result);
    })

  }

  getLeadCount(date1, date2, id, callback) {
    var toSend =
      {start: date1, end: date2, id: Number(id)};
    this.PostAjaxCall(this.BASE_URL + "/lms/lead/getNewCount", toSend, (result) => {
      callback(result);
    })

  }

  /**
   * @author Anand
   * @uses function to calculate time based on UTC offset
   */
  getUserTimeZone() {
    this.usrobj = JSON.parse(localStorage.getItem("user"));
    const offset = this.usrobj.timezone.offset;
    const re = /:/gi;
    let nowOffset: any;
    if (offset.includes("+")) {
      nowOffset = '+' + offset.split("+")[1].replace(re, "");
    } else if (offset.includes("-")) {
      nowOffset = '-' + offset.split("-")[1].replace(re, "");
    } else {
      nowOffset = '+00'
    }
    this._emitterService.setTZ(nowOffset);
  }

  /**
   * @author Pradeep
   * @uses function refresh the token after 2 hours if the system is active
   */
  refreshToken() {

    const thisObj = this;
    const url = this.BASE_URL + "/user/refresh";
    headers.delete('Token');
    //headers.append("Token", localStorage.getItem("token"));
    headers.append("Token", sessionStorage.getItem("token"));
    thisObj._emitterService.setSpinner(false);
    this.http.get(url, {headers: headers})
      .subscribe(
        (data) => {
          const res = data.json();//For Success Response
          thisObj._emitterService.setSpinner(false);
          //localStorage.removeItem('expirytime')
          //localStorage.setItem('expirytime', res.tokenExpiredTime)

          sessionStorage.removeItem('expirytime');
          sessionStorage.setItem('expirytime', res.tokenExpiredTime)
          //callback(res);
        },
        err => {
          thisObj._emitterService.setSpinner(false);
          // localStorage.clear();
          sessionStorage.clear();
          this._router.navigate(['login']);
        }
      );

  }

  /**
   * @author Anand
   * @uses function to calculate time based on UTC offset
   */
  logoutAjaxCall(url: string, params: any, callback) {
    const thisObj = this;
    this._emitterService.setSpinner(true);
    this.http.post(url, params)
      .subscribe(
        (data) => {
          const res = data.json();//For Success Response
          // for timer popup
          thisObj._emitterService.setSpinner(false);
          callback(res);
        },
        err => {
          thisObj._emitterService.setSpinner(false);
          // localStorage.clear();
          sessionStorage.clear();
          thisObj._router.navigate(['login']);
        }
      );
  }

  /**
   * @author Nagendra
   * @description Get Cases count
   * @param userid
   */
  getCaseSummary(userid, callback) {
    this.GetAjaxCall(this.BASE_URL + "/lms/case/dashboard?userId=" + userid, (result) => {
      callback(result);
    })
  }

  /**
   * @author Sowmya
   * @description reset password
   * @param email
   */

  resetPwd(email, callback) {
    this.GetAjaxCall(this.BASE_URL + "/user/forgot/password?email=" + email, (result) => {
      callback(result);
    })
  }


  // Transaction History section start

  /**
   * @author Anand
   * @uses   get lead transaction history
   */
  getLeadsTransaction(id, callback) {
    this.GetAjaxCall(this.BASE_URL + "/lms/individual/getLeads?individualId=" + id, (result) => {
      callback(result);
    })
  }

  /**
   * @author Anand
   * @uses   get CASE transaction history
   */
  getCasesTransaction(id, callback) {
    this.GetAjaxCall(this.BASE_URL + "/lms/individual/getCases?individualId=" + id, (result) => {
      callback(result);
    })
  }

  /**
   * @author Anand
   * @uses   get Owner transaction history
   */
  getOwnersTransaction(id, callback) {
    this.GetAjaxCall(this.BASE_URL + "/lms/individual/getOwners?individualId=" + id, (result) => {
      callback(result);
    })
  }

  /**
   * @author Anand
   * @uses   get owner by vin
   */
  getOwnersByvin(id, callback) {
    this.GetAjaxCall(this.BASE_URL + "/lms/individual/getOwnersByvin?vin=" + id, (result) => {
      callback(result);
    })
  }

  // Transaction History section end

  /**
   * @author Nagendra
   * @description To know the previous route url
   */
  getPreviousUrl() {
    this._router.events
      .filter(e => e instanceof RoutesRecognized)
      .pairwise()
      .subscribe((event: any[]) => {
        this.path = event[0].urlAfterRedirects;
      });
    if (this.path != undefined) {
      return this.path;
    } else {
      return "route";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/services/global-data.service.ts